var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { PureComponent } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Avatar, Card, Image, Tag } from '@philips-internal/oswald-ui-components/lib/components';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';
import { generateUUID, getBreakpoint, trigger } from '@philips-internal/oswald-ui-utils';
import { bool, eventListener, number, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Breakpoint, SelectionType, Size } from '@philips-internal/oswald-ui-constants';
import timeIcon from '../../assets/images/global/hpms-time.svg';
import checkGrayIcon from '../../assets/images/global/check-blue.svg';
import checkIcon from '../../assets/images/global/check-green.svg';
import radiologyLabIcon from '../../assets/images/avatars/radiology_lab.svg';
import laboratoryIcon from '../../assets/images/avatars/avatar_lab.svg';
import './card-exams-list-item.css';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
let CardExamsListItem = class CardExamsListItem extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            data: {},
            visible: true,
            width: 12
        };
    }
    static { this.propTypes = {
        dtProcedimento: string,
        nmExame: string,
        nmPessoaFisica: string,
        nrPrescricao: number,
        onClick: eventListener,
        review: bool.notEnumerable(),
        status: string,
        type: string,
    }; }
    static { this.defaultProps = {
        cardOnSidebar: false,
        review: false,
    }; }
    getStatusInfo(status) {
        switch (status) {
            case 'A':
                return { expression: 'patient.available', icon: checkIcon };
            case 'P':
                return { expression: 'patient.processing', icon: timeIcon };
            case 'R':
                return { expression: 'patient.ready', icon: checkGrayIcon };
            case 'I':
                return { expression: 'patient.status.partially-available', icon: timeIcon };
            default:
                return { expression: '', icon: '' };
        }
    }
    getExamsIcon(examType) {
        switch (examType) {
            case 'L':
                return laboratoryIcon;
            case 'N':
                return radiologyLabIcon;
            case 'P':
                return laboratoryIcon;
            default:
                return '';
        }
    }
    renderStatusIcon(status) {
        const breakpoint = getBreakpoint();
        const isSmallScreen = breakpoint === Breakpoint.SM || breakpoint === Breakpoint.XSM;
        const statusIconInfo = this.getStatusInfo(status?.trim());
        if (isSmallScreen) {
            return null;
        }
        return (React.createElement("div", { className: 'card-right-content' },
            React.createElement("div", { className: 'content-status' },
                React.createElement(Image, { src: statusIconInfo.icon, className: 'status-icon', alt: '' }),
                React.createElement("div", { className: 'content-text-status' }, MessageService.translate(statusIconInfo.expression)))));
    }
    renderAvatar(imageExame) {
        const breakpoint = getBreakpoint();
        const size = breakpoint === Breakpoint.LG ? Size.LARGE : Size.MEDIUM;
        return (React.createElement("div", { className: 'card-avatar' },
            React.createElement(Avatar, { image: imageExame, size: size })));
    }
    renderReviewTag(review) {
        if (!review) {
            return null;
        }
        return (React.createElement("div", { className: 'content-tag' },
            React.createElement(Tag, { value: MessageService.translate('patient.exam-review-tag'), color: 'signal-blue-45' })));
    }
    renderDate(dtProcedimento) {
        return (React.createElement("div", { className: 'content-date' }, ModelService.format('date', dtProcedimento)));
    }
    renderRightInfoContent() {
        const { review, dtProcedimento, cardOnSidebar } = this.props;
        const breakpoint = getBreakpoint();
        if (cardOnSidebar || breakpoint === Breakpoint.XSM) {
            return (React.createElement("div", { className: 'card-right-info-content' },
                this.renderDate(dtProcedimento),
                this.renderReviewTag(review)));
        }
        return (React.createElement("div", { className: 'card-right-info-content' },
            this.renderReviewTag(review),
            this.renderDate(dtProcedimento)));
    }
    render() {
        const { onClick, nmExame, nmPessoaFisica, status } = this.props;
        return (React.createElement(Card, { uuid: generateUUID(), className: 'card-exams-list-item', onClick: trigger(onClick, new ClickEvent()), width: 12, selectionType: SelectionType.NONE },
            React.createElement("div", { className: 'card-content' },
                React.createElement("div", { className: 'card-left-content' },
                    React.createElement("div", { className: 'card-left-info-content' },
                        React.createElement("div", { className: 'content-exame-name' }, nmExame),
                        React.createElement("div", { className: 'content-physician-name' }, `${MessageService.translate('patient.requested-by')} ${nmPessoaFisica}`)),
                    this.renderRightInfoContent()),
                this.renderStatusIcon(status))));
    }
};
CardExamsListItem = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], CardExamsListItem);
export default CardExamsListItem;
//# sourceMappingURL=card-exams-list-item.js.map